export default __webpack_public_path__ + "static/media/top_icon_left.3264ba20.png";